var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.deselectDragObjects,
          expression: "deselectDragObjects",
        },
      ],
      ref: "screen",
      staticClass: "screen-instagram vs-con-loading__container",
      style: `width: ${_vm.screenWidth}px; height: ${
        _vm.screenHeight
      }px; background-color: ${
        _vm.isVideo && _vm.video ? "black" : _vm.imageAverageColor
      }; overflow: ${_vm.isReel ? "visible" : "hidden"}`,
      on: {
        mouseup: _vm.moveTextEnd,
        mousemove: _vm.moveText,
        mousedown: (e) => _vm.deselectDragObjects(null),
      },
    },
    [
      _vm.centerWidget
        ? _c("div", { staticClass: "centered-line-vertical" })
        : _vm._e(),
      _vm.music
        ? _c("audio", {
            ref: "music-story-maker",
            attrs: {
              src: _vm.onlyViewMode
                ? ""
                : _vm.music.track.fast_start_progressive_download_url,
            },
            on: { canplaythrough: (e) => (e.target.volume = "0.5") },
          })
        : _vm._e(),
      _vm.music && _vm.music.config
        ? _c(
            "div",
            { staticClass: "music-config" },
            [
              !_vm.video
                ? _c(
                    "select",
                    {
                      staticClass: "timer-music",
                      on: {
                        focus: _vm.pauseMusic,
                        change: (e) => _vm.setDurationMusic(e.target.value),
                      },
                    },
                    _vm._l(
                      [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
                      function (k) {
                        return _c(
                          "option",
                          {
                            key: k,
                            domProps: {
                              selected: k === _vm.music.duration / 1000,
                              value: k,
                            },
                          },
                          [_vm._v(_vm._s(k))]
                        )
                      }
                    ),
                    0
                  )
                : _c(
                    "select",
                    { staticClass: "timer-music", attrs: { disabled: "" } },
                    [
                      _c(
                        "option",
                        { domProps: { value: _vm.music.duration / 1000 } },
                        [_vm._v(_vm._s(Math.round(_vm.music.duration / 1000)))]
                      ),
                    ]
                  ),
              _c("vue-slider", {
                staticClass: "slider",
                attrs: {
                  dotSize: "10",
                  fixed: true,
                  min: 0,
                  max: _vm.music.track.duration_in_ms,
                  "tooltip-formatter": (ms) =>
                    `${Math.floor(ms / 60000)}:${String(
                      Math.round((ms % 60000) / 1000)
                    ).padStart(2, "0")}`,
                  marks: _vm.music.track.highlight_start_times_in_ms,
                  "hide-label": true,
                  dotStyle: { visibility: "hidden", width: "50px" },
                  processStyle: { backgroundColor: "white", zIndex: 1000 },
                  railStyle: { backgroundColor: "rgb(94,86,83)" },
                },
                on: {
                  "drag-end": () => _vm.setMusicTimer(),
                  "drag-start": () => _vm.pauseMusic(),
                  change: () => _vm.setMusicTimer(),
                },
                model: {
                  value: _vm.musicConfigRange,
                  callback: function ($$v) {
                    _vm.musicConfigRange = $$v
                  },
                  expression: "musicConfigRange",
                },
              }),
              this.$refs["music-story-maker"] &&
              !this.$refs["music-story-maker"].paused
                ? _c("vs-icon", {
                    staticClass: "control",
                    attrs: { icon: "stop_circle" },
                    on: {
                      click: function ($event) {
                        return _vm.pauseMusic()
                      },
                    },
                  })
                : _c("vs-icon", {
                    staticClass: "control",
                    attrs: { icon: "play_arrow" },
                    on: {
                      click: function ($event) {
                        return _vm.playMusic()
                      },
                    },
                  }),
              _c("div", { staticClass: "music-position-container" }, [
                _c("div", {
                  staticClass: "music-position",
                  style: { left: _vm.positionMusicBar },
                }),
              ]),
              _c("div", { staticClass: "music-progress" }, [
                _c("div", {
                  staticClass: "music-percent",
                  style: { width: _vm.percentMusicPlaying },
                }),
              ]),
            ],
            1
          )
        : _vm.music && !_vm.textMode
        ? _c(
            "div",
            {
              staticClass: "music-preview",
              style:
                (_vm.isReel && `bottom: 15px; left: 10px; top: unset;`) ||
                (_vm.onlyViewMode && `top: 30px; left: 5px; scale: 0.7;`),
            },
            [
              _c("img", {
                attrs: {
                  src: "https://media.giphy.com/media/0mKYWcPUzB0Jp4qXsh/giphy.gif",
                },
              }),
              _c("p", [
                _c("b", [_vm._v(_vm._s(_vm.musicPreview[0]))]),
                _vm._v(" . " + _vm._s(_vm.musicPreview[1]) + " ›"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.onlyViewMode && _vm.pageInfo
        ? _c(
            "div",
            {
              staticClass: "page-name",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("vs-avatar", {
                staticClass: "page-img",
                attrs: {
                  color: "transparent",
                  size: "28px",
                  src: _vm.pageInfo.avatar,
                },
              }),
              _c("p", [_vm._v(_vm._s(_vm.pageInfo.name))]),
              _c("span", { staticClass: "page-time" }, [_vm._v("10s")]),
            ],
            1
          )
        : _vm._e(),
      !_vm.video && !_vm.image && !_vm.autoImage
        ? _c("div", { staticClass: "no-image", on: { click: _vm.confirmText } })
        : _vm._e(),
      !_vm.video &&
      !_vm.image &&
      !_vm.autoImage &&
      !_vm.onlyViewMode &&
      !_vm.textMode &&
      !(
        _vm.dragText ||
        _vm.linkMoving ||
        _vm.pollMoving ||
        _vm.sliderMoving ||
        _vm.mentionsWidgetMoving
      ) &&
      !_vm.highlightPopup
        ? _c("vs-button", {
            staticClass: "add-image",
            attrs: {
              radius: "",
              "text-color": "white",
              color: "transparent",
              type: "border",
              icon: "photo_camera",
            },
            on: { click: _vm.addImage },
          })
        : _vm._e(),
      !_vm.video && !_vm.image && _vm.autoImage
        ? _c("div", { staticClass: "background-img" })
        : _vm._e(),
      _vm.isShare
        ? _c(
            "div",
            {
              staticClass: "background-img",
              style: `position: relative; background: linear-gradient(${_vm.gradientSharedImageColor[0]}, ${_vm.gradientSharedImageColor[1]})`,
            },
            [
              _vm.isVisualShare
                ? _c("div", {
                    staticClass: "share-visual",
                    style: `left: ${_vm.screenWidth / 2}px; top: ${
                      _vm.screenHeight / 2
                    }px; height: ${_vm.shareImageHeight + 90}px;`,
                  })
                : _vm._e(),
              _vm.isVisualShare
                ? _c("img", {
                    staticClass: "share-visual-avatar",
                    style: `top: ${
                      _vm.screenHeight / 2 - _vm.shareImageHeight / 2 - 23
                    }px;`,
                    attrs: { src: _vm.picProfil, alt: "" },
                  })
                : _vm._e(),
              _vm.isVisualShare
                ? _c(
                    "p",
                    {
                      staticClass: "share-visual-username",
                      style: `top: ${
                        _vm.screenHeight / 2 - _vm.shareImageHeight / 2 - 28
                      }px;`,
                    },
                    [_vm._v(_vm._s(_vm.usernameShared))]
                  )
                : _vm._e(),
              _vm.isVisualShare
                ? _c(
                    "p",
                    {
                      staticClass: "share-visual-text",
                      style: `top: ${
                        _vm.screenHeight / 2 + _vm.shareImageHeight / 2 + 6
                      }px;`,
                    },
                    [
                      _c("span", [_vm._v(_vm._s(_vm.usernameShared))]),
                      _vm._v("  " + _vm._s(_vm.isVisualShare)),
                    ]
                  )
                : _vm._e(),
              _c("img", {
                staticClass: "share-img",
                style: `left: ${_vm.screenWidth / 2}px; top: ${
                  _vm.screenHeight / 2
                }px;`,
                attrs: { src: _vm.image, alt: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggleVisual")
                  },
                  load: _vm.shareLoadImage,
                },
              }),
              !_vm.isVisualShare
                ? _c(
                    "p",
                    {
                      staticClass: "share-user",
                      style: `top: ${
                        _vm.screenHeight / 2 + _vm.shareImageHeight / 2 + 6
                      }px;`,
                    },
                    [_vm._v("@" + _vm._s(_vm.usernameShared))]
                  )
                : _vm._e(),
            ]
          )
        : _vm.isVideo && _vm.video && typeof _vm.video === "string"
        ? _c("video", {
            ref: "video-story-maker",
            staticClass: "background-img",
            style: `${_vm.linkMoving && "pointer-events: none;"}`,
            attrs: {
              crossorigin: "anonymous",
              src: _vm.video + "?no-cache",
              draggable: "false",
              controls: "",
              poster:
                _vm.isReel &&
                (_vm.injectedImage ||
                  (_vm.post.page &&
                    _vm.post.page[0] &&
                    _vm.post.page[0].enclosure) ||
                  _vm.post.enclosure)
                  ? _vm.injectedImage ||
                    _vm.post.enclosure ||
                    _vm.post.page[0].enclosure
                  : null,
            },
            on: {
              canplaythrough: (e) => _vm.music && (e.target.volume = "0.5"),
              play: _vm.playMusic,
              pause: _vm.pauseMusic,
              seeked: _vm.setMusicSeek,
              volumechange: _vm.muteVideoIfMusic,
            },
          })
        : _vm.image
        ? _c("img", {
            ref: "main-img",
            staticClass: "background-img",
            style: `background-color: ${_vm.imageAverageColor};`,
            attrs: {
              draggable: "false",
              src: _vm.image,
              alt: "Image",
              id: "main-img",
            },
            on: {
              click: _vm.confirmText,
              dragstart: function ($event) {
                $event.preventDefault()
              },
            },
          })
        : _vm._e(),
      _vm.template && _vm.template !== "custom"
        ? _c("img", {
            staticClass: "template-img",
            style: `width: ${_vm.screenWidth}px; height: ${_vm.screenHeight}px`,
            attrs: {
              src: `https://s3.eu-west-1.amazonaws.com/saas.mashup.sandbox/img/${_vm.template}.png`,
              alt: "",
            },
          })
        : _vm._e(),
      _vm._l(_vm.layers, function (layer) {
        return _c("img", {
          key: layer.url,
          style: {
            width: `${layer.w / (1080 / _vm.screenWidth)}px`,
            height: `${layer.h / (1080 / _vm.screenWidth)}px`,
            left: `${layer.x / (1080 / _vm.screenWidth)}px`,
            top: `${layer.y / (1080 / _vm.screenWidth)}px`,
            position: "absolute",
          },
          attrs: { src: layer.url, alt: "" },
        })
      }),
      !_vm.cropMode &&
      !_vm.isShare &&
      !_vm.isVideo &&
      _vm.manualLayers &&
      !_vm.onlyViewMode
        ? _c(
            "div",
            { staticClass: "gifs-container" },
            _vm._l(_vm.manualLayers, function (layer, i) {
              return _c("img", {
                key: i.toString() + _vm.onlyViewMode,
                class: `image-layer image-layer-${_vm.onlyViewMode}`,
                style: `max-width: ${_vm.screenWidth}px;`,
                attrs: {
                  id: `layer-${i}-${_vm.onlyViewMode}`,
                  src: layer.reader || layer.url,
                  alt: i,
                },
                on: { mousedown: (e) => _vm.setLayerSelected(e, i) },
              })
            }),
            0
          )
        : _vm._e(),
      !_vm.cropMode &&
      !_vm.isShare &&
      !_vm.isVideo &&
      _vm.manualLayers &&
      _vm.onlyViewMode
        ? _c(
            "div",
            { staticClass: "gifs-container" },
            _vm._l(_vm.manualLayers, function (layer, i) {
              return _c("img", {
                key: i.toString() + _vm.onlyViewMode,
                class: `image-layer image-layer-${_vm.onlyViewMode}`,
                style: `left: ${layer.x}; top: ${layer.y}; width: ${layer.w}; max-width: ${_vm.screenWidth}px`,
                attrs: {
                  id: `layer-${i}-${_vm.onlyViewMode}`,
                  src: layer.reader || layer.url,
                  alt: i,
                },
              })
            }),
            0
          )
        : _vm._e(),
      !_vm.cropMode && !_vm.isShare && _vm.gifs && !_vm.onlyViewMode
        ? _c(
            "div",
            { staticClass: "gifs-container" },
            _vm._l(_vm.gifs, function (gif, i) {
              return _c("img", {
                key: gif.id + _vm.onlyViewMode,
                class: `image-gifs image-gif-${_vm.onlyViewMode}`,
                style: `max-width: ${_vm.screenWidth}px; border: ${
                  gif.id === _vm.gifSelected
                    ? "2px solid rgb(222, 6, 136)"
                    : "none"
                }`,
                attrs: {
                  id: `gif-${i}-${_vm.onlyViewMode}`,
                  src: gif.images.preview_gif.url,
                  alt: gif.name,
                },
                on: { mousedown: (e) => _vm.setGifBorder(e, gif.id) },
              })
            }),
            0
          )
        : _vm._e(),
      !_vm.cropMode && !_vm.isShare && _vm.gifs && _vm.onlyViewMode
        ? _c(
            "div",
            { staticClass: "gifs-container" },
            _vm._l(_vm.gifs, function (gif, i) {
              return _c("img", {
                key: gif.id + _vm.onlyViewMode,
                class: `image-gifs image-gif-${_vm.onlyViewMode}`,
                style: `left: ${gif.x}; top: ${gif.y}; width: ${
                  gif.w
                }; max-width: ${_vm.screenWidth}px; border: ${
                  gif.id === _vm.gifSelected
                    ? "2px solid rgb(222, 6, 136)"
                    : "none"
                }`,
                attrs: {
                  id: `gif-${i}-${_vm.onlyViewMode}`,
                  src: gif.images.preview_gif.url,
                  alt: gif.name,
                },
              })
            }),
            0
          )
        : _vm._e(),
      _vm._l(_vm.mentionsWidget, function (mention, i) {
        return _c(
          "div",
          {
            key: mention.pk,
            class: `mentions-widget mention-widget-${
              _vm.onlyViewMode
            } style-mention${mention.color} ${
              mention.hide ? "hidden-mention" : ""
            }`,
            attrs: { id: `mention-widget-${i}-${_vm.onlyViewMode}` },
            on: {
              click: () => _vm.changeMentionWidgetColor(i),
              mousedown: (e) => _vm.setMentionSelected(e, mention.pk),
            },
          },
          [
            mention.color === 3
              ? _c("span", { staticClass: "mention-widget-text" }, [
                  _c("span", { staticClass: "arobase" }, [_vm._v("@")]),
                  _vm._v(_vm._s(mention.id)),
                ])
              : _c("span", { staticClass: "mention-widget-text" }, [
                  _vm._v("@" + _vm._s(mention.id)),
                ]),
          ]
        )
      }),
      _vm.isReel && !(_vm.music && _vm.music.config)
        ? _c("div", { staticClass: "reel-cta" }, [
            _c("div", [
              _c(
                "svg",
                {
                  staticClass: "_8-yf5",
                  attrs: {
                    "aria-label": "J’aime",
                    fill: "#FFF",
                    height: "24",
                    viewBox: "0 0 48 48",
                    width: "24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M34.6 6.1c5.7 0 10.4 5.2 10.4 11.5 0 6.8-5.9 11-11.5 16S25 41.3 24 41.9c-1.1-.7-4.7-4-9.5-8.3-5.7-5-11.5-9.2-11.5-16C3 11.3 7.7 6.1 13.4 6.1c4.2 0 6.5 2 8.1 4.3 1.9 2.6 2.2 3.9 2.5 3.9.3 0 .6-1.3 2.5-3.9 1.6-2.3 3.9-4.3 8.1-4.3m0-3c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5.6 0 1.1-.2 1.6-.5 1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z",
                    },
                  }),
                ]
              ),
            ]),
            _c("div", [
              _c(
                "svg",
                {
                  staticClass: "_8-yf5",
                  attrs: {
                    "aria-label": "Commenter",
                    fill: "#FFF",
                    height: "24",
                    viewBox: "0 0 48 48",
                    width: "24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "clip-rule": "evenodd",
                      d: "M47.5 46.1l-2.8-11c1.8-3.3 2.8-7.1 2.8-11.1C47.5 11 37 .5 24 .5S.5 11 .5 24 11 47.5 24 47.5c4 0 7.8-1 11.1-2.8l11 2.8c.8.2 1.6-.6 1.4-1.4zm-3-22.1c0 4-1 7-2.6 10-.2.4-.3.9-.2 1.4l2.1 8.4-8.3-2.1c-.5-.1-1-.1-1.4.2-1.8 1-5.2 2.6-10 2.6-11.4 0-20.6-9.2-20.6-20.5S12.7 3.5 24 3.5 44.5 12.7 44.5 24z",
                      "fill-rule": "evenodd",
                    },
                  }),
                ]
              ),
            ]),
            _c("div", [
              _c(
                "svg",
                {
                  staticClass: "_8-yf5",
                  attrs: {
                    "aria-label": "Partager la publication",
                    fill: "#FFF",
                    height: "24",
                    viewBox: "0 0 48 48",
                    width: "24",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M47.8 3.8c-.3-.5-.8-.8-1.3-.8h-45C.9 3.1.3 3.5.1 4S0 5.2.4 5.7l15.9 15.6 5.5 22.6c.1.6.6 1 1.2 1.1h.2c.5 0 1-.3 1.3-.7l23.2-39c.4-.4.4-1 .1-1.5zM5.2 6.1h35.5L18 18.7 5.2 6.1zm18.7 33.6l-4.4-18.4L42.4 8.6 23.9 39.7z",
                    },
                  }),
                ]
              ),
            ]),
            _c("div", [_vm._v(". . .")]),
          ])
        : _vm._e(),
      !_vm.textMode && !_vm.cropMode && !_vm.onlyViewMode
        ? _c(
            "div",
            {
              staticClass: "icons-bar",
              attrs: { "data-html2canvas-ignore": "" },
            },
            [
              !_vm.isReel
                ? _c("div", {
                    staticClass: "remove-img icons-white icons",
                    on: { click: () => (_vm.confirmDelete = true) },
                  })
                : _vm.isReel
                ? _c("div", [
                    _c("p", { staticClass: "reel-name" }, [_vm._v("Reels")]),
                  ])
                : _vm._e(),
              _vm.image && !_vm.isVideo && !_vm.isShare
                ? _c("img", {
                    staticClass: "crop-img icons-white",
                    attrs: {
                      src: require("../../assets/img/icon_instagram_pencil.svg"),
                      alt: "Crop",
                    },
                    on: { click: _vm.cropImage },
                  })
                : _vm._e(),
              !_vm.isShare
                ? _c("div", {
                    staticClass: "add-text-icon icons icons-white",
                    attrs: { "no-deselect": "" },
                    on: { click: _vm.addText },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.confirmDelete
        ? _c("div", {
            staticClass: "popup-disable-background icons-white",
            attrs: { "data-html2canvas-ignore": "" },
          })
        : _vm._e(),
      _vm.confirmDelete
        ? _c("div", { staticClass: "popup-remove-img" }, [
            _vm._m(0),
            _c("div", { staticClass: "btn-remove-img" }, [
              _c(
                "button",
                {
                  staticClass: "cancel-remove-img",
                  attrs: { tabindex: "0" },
                  on: { click: () => (_vm.confirmDelete = false) },
                },
                [_vm._v("\n        Conserver\n      ")]
              ),
              _c(
                "button",
                {
                  staticClass: "confirm-remove-img",
                  attrs: { tabindex: "0" },
                  on: { click: _vm.resetStory },
                },
                [_vm._v("\n        Abandonner\n      ")]
              ),
            ]),
          ])
        : _vm._e(),
      _vm.textMode
        ? _c(
            "div",
            {
              staticClass: "justify icons-white",
              attrs: { "data-html2canvas-ignore": "" },
            },
            [
              _vm.justify === "center"
                ? _c("img", {
                    attrs: {
                      src: require("../../assets/img/icon_instagram_justify_center.png"),
                      alt: "center",
                    },
                    on: { click: _vm.justifyText },
                  })
                : _vm._e(),
              _vm.justify === "left"
                ? _c("img", {
                    attrs: {
                      src: require("../../assets/img/icon_instagram_justify_left.png"),
                      alt: "left",
                    },
                    on: { click: _vm.justifyText },
                  })
                : _vm._e(),
              _vm.justify === "right"
                ? _c("img", {
                    staticClass: "reverse",
                    attrs: {
                      src: require("../../assets/img/icon_instagram_justify_left.png"),
                      alt: "right",
                    },
                    on: { click: _vm.justifyText },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.textMode
        ? _c("img", {
            staticClass: "color-switch",
            attrs: {
              src: require("../../assets/img/icon_instagram_color.png"),
              alt: "",
              "data-html2canvas-ignore": "",
            },
            on: {
              click: function ($event) {
                ;[
                  (_vm.colorSwitch = !_vm.colorSwitch),
                  _vm.nextTickSetEndOfContenteditable(),
                ]
              },
            },
          })
        : _vm._e(),
      _vm.textMode
        ? _c("img", {
            staticClass: "fond-text icons-white",
            attrs: {
              src: require(`../../assets/img/icon_instagram_fond${
                _vm.text[_vm.currentTextIndex].background === 0 ? 1 : 2
              }.png`),
              alt: "FOND",
              "data-html2canvas-ignore": "",
            },
            on: {
              click: function ($event) {
                ;[
                  (_vm.text[_vm.currentTextIndex].background =
                    (_vm.text[_vm.currentTextIndex].background + 1) %
                    (_vm.text[_vm.currentTextIndex].font === 3 ? 2 : 3)),
                  _vm.nextTickSetEndOfContenteditable(),
                ]
              },
            },
          })
        : _vm._e(),
      _vm.textMode
        ? _c(
            "vs-button",
            {
              staticClass: "confirm-text",
              attrs: { type: "flat", "data-html2canvas-ignore": "" },
              on: { click: _vm.confirmText },
            },
            [
              _c("span", { staticClass: "icons-white txt-btn" }, [
                _vm._v("Terminer"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.cropMode
        ? _c(
            "vs-button",
            {
              staticClass: "cancel-crop confirm-text icons-white",
              attrs: { type: "flat", "data-html2canvas-ignore": "" },
              on: { click: _vm.cancelCrop },
            },
            [
              _c("span", { staticClass: "icons-white txt-btn" }, [
                _vm._v("Annuler"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.cropMode
        ? _c(
            "vs-button",
            {
              staticClass: "confirm-text icons-white",
              attrs: { type: "flat", "data-html2canvas-ignore": "" },
              on: { click: _vm.confirmCrop },
            },
            [
              _c("span", { staticClass: "icons-white txt-btn" }, [
                _vm._v("Sauvegarder"),
              ]),
            ]
          )
        : _vm._e(),
      _vm.textMode
        ? _c("img", {
            staticClass: "slider-size icons-white loupe-plus",
            attrs: {
              src: require("../../assets/img/icon_instagram_txt_plus.png"),
              alt: "+",
              "data-html2canvas-ignore": "",
            },
          })
        : _vm._e(),
      _vm.textMode
        ? _c("vue-slider", {
            staticClass: "slider-size",
            attrs: {
              height: 350,
              direction: "btt",
              min: 15,
              max: 75,
              width: 7,
              tooltip: "active",
              "tooltip-placement": "right",
              dotSize: 17,
              "process-style": { backgroundColor: "#B20565" },
              "dot-style": {
                backgroundColor: "#B20565",
                borderColor: "#F8F8F8",
              },
              "rail-style": { backgroundColor: "white" },
              "data-html2canvas-ignore": "",
            },
            on: { "drag-end": _vm.changeSize },
            model: {
              value: _vm.text[_vm.currentTextIndex].size,
              callback: function ($$v) {
                _vm.$set(_vm.text[_vm.currentTextIndex], "size", $$v)
              },
              expression: "text[currentTextIndex].size",
            },
          })
        : _vm._e(),
      _vm.textMode
        ? _c("img", {
            staticClass: "icons-white slider-size loupe-moins",
            attrs: {
              src: require("../../assets/img/icon_instagram_txt_moins.png"),
              alt: "-",
              "data-html2canvas-ignore": "",
            },
          })
        : _vm._e(),
      _vm.cropMode
        ? _c("img", {
            staticClass: "slider-size icons-white loupe-plus",
            attrs: {
              src: require("../../assets/img/icon_instagram_loupe_plus.svg"),
              alt: "+",
              "data-html2canvas-ignore": "",
            },
          })
        : _vm._e(),
      _vm.cropMode
        ? _c("vue-slider", {
            staticClass: "slider-size",
            attrs: {
              height: 350,
              direction: "btt",
              min: 0.01,
              max: 3,
              interval: 0.01,
              width: 5,
              tooltip: "hover",
              "tooltip-placement": "right",
              dotSize: 15,
              "process-style": { backgroundColor: "#B20565" },
              "dot-style": {
                backgroundColor: "#B20565",
                borderColor: "#F8F8F8",
              },
              "rail-style": { backgroundColor: "white" },
              "data-html2canvas-ignore": "",
            },
            on: { change: _vm.changeZoom },
            model: {
              value: _vm.cropZoom,
              callback: function ($$v) {
                _vm.cropZoom = $$v
              },
              expression: "cropZoom",
            },
          })
        : _vm._e(),
      _vm.cropMode
        ? _c("img", {
            staticClass: "slider-size icons-white loupe-moins",
            attrs: {
              src: require("../../assets/img/icon_instagram_loupe_moins.svg"),
              alt: "-",
              "data-html2canvas-ignore": "",
            },
          })
        : _vm._e(),
      _vm._l(_vm.text, function (txt, idx) {
        return _c("span", { key: idx }, [
          (_vm.textMode && _vm.currentTextIndex === idx ? "none" : "")
            ? _c("img", {
                staticClass: "rotation-btn",
                style: `left:${_vm.rotatedPosition(idx).x}px; top:${
                  _vm.rotatedPosition(idx).y
                }px; width:${txt.size / 2}px;`,
                attrs: {
                  src: require("../../assets/img/icon_instagram_rotate_txt.svg"),
                  alt: "rotate",
                  "data-html2canvas-ignore": "",
                },
                on: {
                  dragstart: function ($event) {
                    $event.preventDefault()
                  },
                  mousedown: (e) => _vm.rotateTextBegin(e, idx),
                },
              })
            : _vm._e(),
          !_vm.isShare &&
          txt.content &&
          !_vm.cropMode &&
          (!_vm.textMode || _vm.onlyViewMode || _vm.currentTextIndex !== idx)
            ? _c(
                "p",
                {
                  ref: `text${idx}`,
                  refInFor: true,
                  class: `text font${txt.font} ${
                    txt.background !== 0 ? "fond" : ""
                  }`,
                  style: `
      color: ${
        txt.background === 2 || _vm.preview
          ? ["white", "#FFF", "#FFFFFF"].includes(txt.color)
            ? "black"
            : "white"
          : txt.background === 1 && txt.font === 3
          ? "white"
          : txt.color
      }; 
      font-size: ${txt.size}px; 
      left:${txt.x - (_vm.template === "custom" && _vm.textStatic ? 50 : 0)}px; 
      top:${txt.y - (_vm.template === "custom" && _vm.textStatic ? 30 : 0)}px; 
      transform: rotate(${txt.angle}deg) ${
                    _vm.textCenter ? "translate(-50%, -50%)" : ""
                  };
      ${
        txt.background !== 0
          ? "padding-top:" +
            (txt.font === 3 ? "0;" : txt.font === 2 ? "16px;" : "7px;")
          : "padding-top:" +
            (txt.font === 3 ? "-10px;" : txt.font === 2 ? "12px;" : "3px;")
      } width: ${_vm.preview ? "80%" : ""}`,
                  attrs: { "no-deselect": "" },
                  on: {
                    mousedown: (e) => _vm.moveTextBegin(e, idx),
                    click: function ($event) {
                      return _vm.modifyText(idx)
                    },
                  },
                },
                [
                  _c(
                    "span",
                    {
                      class: `background-txt-custom-${txt.font} font${txt.font}`,
                      style: `display: inline-block; white-space: pre-line; background-color: ${
                        txt.background === 2
                          ? txt.color
                          : txt.background === 1
                          ? ["white", "#FFF", "#FFFFFF"].includes(txt.color)
                            ? "black"
                            : "white"
                          : "transparent"
                      };
        text-shadow: ${
          txt.background === 1 && txt.font === 3
            ? "1px 1px 2px black, 0 0 10px " +
              (txt.color.includes("#")
                ? txt.color
                : ["black", "#000", "#000000"].includes(txt.color)
                ? "#000000"
                : "#FFFFFF") +
              ", 0 0 1px" +
              (txt.color.includes("#")
                ? txt.color
                : ["black", "#000", "#000000"].includes(txt.color)
                ? "#000000"
                : "#FFFFFF") +
              ";"
            : "none"
        };`,
                      attrs: { "no-deselect": "" },
                    },
                    [_vm._v(_vm._s(_vm.textPreview[idx]))]
                  ),
                ]
              )
            : !_vm.isShare &&
              txt !== null &&
              !_vm.cropMode &&
              _vm.currentTextIndex === idx
            ? _c(
                "div",
                {
                  class: `text font${txt.font} ${
                    txt.background !== 0 ? "fond" : ""
                  }`,
                  style: `color: ${
                    txt.background === 2
                      ? ["white", "#FFF", "#FFFFFF"].includes(txt.color)
                        ? "black"
                        : "white"
                      : txt.background === 1 && txt.font === 3
                      ? "white"
                      : txt.color
                  }; font-size: ${txt.size}px; left:${txt.x}px; top:${
                    txt.y
                  }px; border:${
                    !_vm.textMode && !_vm.dragText && txt.background === 0
                      ? "none"
                      : _vm.currentTextIndex !== idx
                      ? "none"
                      : ""
                  }; ${
                    txt.background !== 0
                      ? "padding-top:" +
                        (txt.font === 3
                          ? "0;"
                          : txt.font === 2
                          ? "16px;"
                          : "7px;")
                      : "padding-top:" +
                        (txt.font === 3
                          ? "-10px;"
                          : txt.font === 2
                          ? "12px;"
                          : "3px;")
                  }
         border: ${
           txt.background === 0 && txt.content.trim() !== ""
             ? "rgba(255, 255, 255, 0.3) solid 1px"
             : "none"
         };
         transform: rotate(${txt.angle}deg); `,
                },
                [
                  _c("contenteditable", {
                    ref: `text${idx}`,
                    refInFor: true,
                    class: `background-txt-custom-${txt.font} font${txt.font}`,
                    style: `display: inline-block; background:${
                      !_vm.textMode && !_vm.dragText && txt.background === 0
                        ? "none"
                        : _vm.currentTextIndex !== idx && txt.background === 0
                        ? "none"
                        : ""
                    }; 
        background-color: ${
          txt.background === 2
            ? txt.color
            : txt.background === 1
            ? ["white", "#FFF", "#FFFFFF"].includes(txt.color)
              ? "black"
              : "white"
            : "transparent"
        };
        color: ${
          txt.background === 2
            ? ["white", "#FFF", "#FFFFFF"].includes(txt.color)
              ? "black"
              : "white"
            : txt.background === 1 && txt.font === 3
            ? "white"
            : txt.color
        };
        text-shadow: ${
          txt.background === 1 && txt.font === 3
            ? "1px 1px 2px black, 0 0 10px " +
              (txt.color.includes("#")
                ? txt.color
                : ["black", "#000", "#000000"].includes(txt.color)
                ? "#000000"
                : "#FFFFFF") +
              ", 0 0 1px" +
              (txt.color.includes("#")
                ? txt.color
                : ["black", "#000", "#000000"].includes(txt.color)
                ? "#000000"
                : "#FFFFFF") +
              ";"
            : "none"
        };`,
                    attrs: {
                      tag: "span",
                      contenteditable: _vm.textMode && !_vm.onlyViewMode,
                      noNL: false,
                      noHTML: true,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.modifyText(idx)
                      },
                      mousedown: (e) => _vm.moveTextBegin(e, idx),
                    },
                    model: {
                      value: txt.content,
                      callback: function ($$v) {
                        _vm.$set(txt, "content", $$v)
                      },
                      expression: "txt.content",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ])
      }),
      _vm.textMode && _vm.colorSwitch
        ? _c(
            "div",
            {
              staticClass: "colors-text",
              attrs: { "data-html2canvas-ignore": "" },
            },
            _vm._l(_vm.colors, function (color) {
              return _c("div", {
                key: color,
                staticClass: "color",
                style: `background-color: ${color}; border-color: ${
                  color === "white" ? "black" : "white"
                }`,
                on: {
                  click: function ($event) {
                    return _vm.changeColor(color)
                  },
                },
              })
            }),
            0
          )
        : _vm._e(),
      (_vm.dragText ||
        _vm.linkMoving ||
        _vm.pollMoving ||
        _vm.sliderMoving ||
        _vm.mentionsWidgetMoving) &&
      !_vm.highlightPopup
        ? _c(
            "div",
            {
              staticClass: "delete-text",
              attrs: { "data-html2canvas-ignore": "" },
            },
            [
              _c("div", {
                staticClass: "circle",
                on: { mouseup: _vm.deleteWidget },
              }),
              _c("img", {
                staticClass: "delete-img",
                attrs: {
                  src: require("../../assets/img/icon_instagram_trash.svg"),
                  alt: "Delete",
                },
              }),
            ]
          )
        : _vm._e(),
      !_vm.textMode && !_vm.dragText && _vm.cropMode
        ? _c(
            "div",
            {
              staticClass: "img-transform",
              attrs: { "data-html2canvas-ignore": "" },
            },
            [
              _c("img", {
                staticClass: "icon-rotate icons-white txt-btn",
                attrs: {
                  src: require("../../assets/img/icon_instagram_rotate.svg"),
                  alt: "rotate +",
                },
                on: { click: () => _vm.cropper.rotate(45) },
              }),
              _c("img", {
                staticClass: "icon-rotate icons-white txt-btn",
                attrs: {
                  src: require("../../assets/img/icon_instagram_rotate_neg.svg"),
                  alt: "rotate -",
                },
                on: { click: () => _vm.cropper.rotate(-45) },
              }),
              _c("img", {
                staticClass: "icon-rotate icons-white txt-btn",
                attrs: {
                  src: require("../../assets/img/icon_instagram_inverse_x.svg"),
                  alt: "inverse x",
                },
                on: {
                  click: () =>
                    _vm.cropper.scaleX(_vm.cropper.getImageData().scaleX * -1),
                },
              }),
              _c("img", {
                staticClass: "icon-rotate icons-white txt-btn",
                attrs: {
                  src: require("../../assets/img/icon_instagram_inverse_y.svg"),
                  alt: "inverse y",
                },
                on: {
                  click: () =>
                    _vm.cropper.scaleY(_vm.cropper.getImageData().scaleY * -1),
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.textMode && !_vm.dragText && !_vm.highlightPopup
        ? _c(
            "div",
            {
              staticClass: "fonts-text",
              attrs: { "data-html2canvas-ignore": "" },
            },
            _vm._l(4, function (k) {
              return _c(
                "span",
                {
                  key: k,
                  class: `font${k} font`,
                  style: `background-color: ${
                    k === _vm.text[_vm.currentTextIndex].font
                      ? "white;"
                      : "#26262670;"
                  } color: ${
                    k === _vm.text[_vm.currentTextIndex].font
                      ? "#ba3420"
                      : "white"
                  }`,
                  on: {
                    click: function ($event) {
                      return _vm.textFont(k)
                    },
                  },
                },
                [_vm._v("Aa")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm.highlightPopup && !_vm.onlyViewMode && _vm.enableHighlight
        ? _c("div", {
            staticClass: "close-highlight",
            on: { click: _vm.selectHighlight },
          })
        : _vm._e(),
      _vm.highlightPopup && !_vm.onlyViewMode && _vm.enableHighlight
        ? _c("p", { staticClass: "p-highlight" }, [
            _vm._v("Ajouter aux éléments à la une"),
          ])
        : _vm._e(),
      _vm.highlightPopup && !_vm.onlyViewMode && _vm.enableHighlight
        ? _c(
            "div",
            {
              ref: "loadingHighlight",
              staticClass: "highlights vs-con-loading__container",
              attrs: { "data-html2canvas-ignore": "" },
            },
            [
              _c(
                "label",
                { staticClass: "highlight" },
                [
                  _c("vs-radio", {
                    staticClass: "hidden",
                    attrs: { "vs-value": null },
                    model: {
                      value: _vm.currentHighlight,
                      callback: function ($$v) {
                        _vm.currentHighlight = $$v
                      },
                      expression: "currentHighlight",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "highlight-img",
                      style:
                        _vm.currentHighlight === null &&
                        "border: solid 2.5px white",
                    },
                    [_vm._v("\n        X\n      ")]
                  ),
                  _vm._v("\n      Aucun\n    "),
                ],
                1
              ),
              _vm._l(_vm.highlightsPage, function (h) {
                return _c(
                  "label",
                  { key: h.title, staticClass: "highlight" },
                  [
                    _c("vs-radio", {
                      staticClass: "hidden",
                      attrs: { "vs-value": h.title },
                      on: { change: _vm.selectHighlight },
                      model: {
                        value: _vm.currentHighlight,
                        callback: function ($$v) {
                          _vm.currentHighlight = $$v
                        },
                        expression: "currentHighlight",
                      },
                    }),
                    _c("img", {
                      staticClass: "highlight-img",
                      style:
                        _vm.currentHighlight === h.title &&
                        "border: solid 2.5px white",
                      attrs: { src: h.img, alt: "" },
                    }),
                    _vm._v("\n      " + _vm._s(h.title) + "\n    "),
                  ],
                  1
                )
              }),
              _c(
                "label",
                { staticClass: "highlight" },
                [
                  _c("vs-radio", {
                    staticClass: "hidden",
                    attrs: { "vs-value": "__new_highlight__" },
                    model: {
                      value: _vm.currentHighlight,
                      callback: function ($$v) {
                        _vm.currentHighlight = $$v
                      },
                      expression: "currentHighlight",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "highlight-img",
                      style:
                        _vm.currentHighlight === "__new_highlight__" &&
                        "border: solid 2.5px white",
                    },
                    [_vm._v("\n        +\n      ")]
                  ),
                  _c("vs-input", {
                    staticClass: "new-highlight",
                    style:
                      _vm.currentHighlight === "__new_highlight__" &&
                      "border: solid 1px white",
                    attrs: {
                      size: "small",
                      danger: !_vm.isValidHightlight,
                      "danger-text": "Invalide",
                    },
                    model: {
                      value: _vm.newHighlight,
                      callback: function ($$v) {
                        _vm.newHighlight = $$v
                      },
                      expression: "newHighlight",
                    },
                  }),
                ],
                1
              ),
            ],
            2
          )
        : _vm.enableHighlight &&
          !_vm.cropMode &&
          !_vm.textMode &&
          !_vm.onlyViewMode &&
          !_vm.isReel
        ? _c("img", {
            staticClass: "highlight-icon icons-white",
            attrs: {
              src: _vm.currentHighlightThumbnail,
              alt: "",
              "data-html2canvas-ignore": "",
            },
            on: { click: _vm.openHighlight },
          })
        : _vm._e(),
      _vm.link && !_vm.cropMode && !_vm.onlyViewMode
        ? _c(
            "div",
            {
              ref: "link",
              class: `link-container style-link${_vm.linkColor} ${
                !_vm.onlyViewMode && "draggable-link"
              }`,
              style: {
                left: _vm.leftLinkPos,
                cursor: _vm.onlyViewMode && "pointer",
              },
              attrs: { id: "link-container" },
              on: { click: _vm.changeLinkColor },
            },
            [
              _c("img", {
                staticClass: "link-img",
                attrs: {
                  src: require("../../assets/img/icon_instagram_link.svg"),
                  alt: "Link",
                },
              }),
              _c("p", { staticClass: "link-txt" }, [
                _vm._v(
                  _vm._s(
                    _vm.linkText
                      ? _vm.linkText.toUpperCase()
                      : _vm.link
                          .split("/")[2]
                          .toUpperCase()
                          .split("?")[0]
                          .replace("WWW.", "")
                  )
                ),
              ]),
              _c("div", { staticClass: "corner edge-top edge-left" }),
              _c("div", { staticClass: "corner edge-top edge-right" }),
              _c("div", { staticClass: "corner edge-bottom edge-right" }),
              _c("div", { staticClass: "corner edge-bottom edge-left" }),
            ]
          )
        : _vm._e(),
      _vm.link && !_vm.cropMode && _vm.onlyViewMode && _vm.posiLink
        ? _c(
            "div",
            {
              ref: "link",
              class: `link-container-view style-link${_vm.linkColor}`,
              style: {
                transform: `translate(${_vm.posiLink.x}px,${
                  _vm.posiLink.y
                }px) translateX(-50%) rotate(${
                  _vm.posiLink.angle || 0
                }rad) scale(${_vm.posiLink.scale || 1})`,
                top: `-15px`,
                cursor: _vm.onlyViewMode && "pointer",
              },
              attrs: { id: "link-container" },
              on: { click: _vm.linkAction },
            },
            [
              _c("img", {
                staticClass: "link-img",
                attrs: {
                  src: require("../../assets/img/icon_instagram_link.svg"),
                  alt: "Link",
                },
              }),
              _c("p", { staticClass: "link-txt" }, [
                _vm._v(
                  _vm._s(
                    _vm.linkText
                      ? _vm.linkText.toUpperCase()
                      : _vm.link
                          .split("/")[2]
                          .toUpperCase()
                          .split("?")[0]
                          .replace("WWW.", "")
                  )
                ),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.isShare && _vm.poll && !_vm.onlyViewMode
        ? _c(
            "div",
            {
              ref: "poll",
              class: `poll-container-v2 ${
                !_vm.onlyViewMode && "draggable-poll"
              }`,
              attrs: { id: "poll-container" },
            },
            [
              _vm.poll.question.length > 0
                ? _c("div", { staticClass: "poll-question" }, [
                    _c("p", {}, [
                      _vm._v(_vm._s(_vm.poll.question || "Question ?")),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "poll-choices" }, [
                _c("span", { staticClass: "choice-container" }, [
                  _c(
                    "span",
                    {
                      staticClass: "text-choice",
                      attrs: { id: "poll-option-1" },
                    },
                    [_vm._v(_vm._s(_vm.poll.options[0] || "Oui"))]
                  ),
                ]),
                _c("span", { staticClass: "choice-container" }, [
                  _c(
                    "span",
                    {
                      staticClass: "text-choice",
                      attrs: { id: "poll-option-2" },
                    },
                    [_vm._v(_vm._s(_vm.poll.options[1] || "Non"))]
                  ),
                ]),
                _vm.poll.options[2]
                  ? _c("span", { staticClass: "choice-container" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text-choice",
                          attrs: { id: "poll-option-2" },
                        },
                        [_vm._v(_vm._s(_vm.poll.options[2]))]
                      ),
                    ])
                  : _vm._e(),
                _vm.poll.options[3]
                  ? _c("span", { staticClass: "choice-container" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text-choice",
                          attrs: { id: "poll-option-2" },
                        },
                        [_vm._v(_vm._s(_vm.poll.options[3]))]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : !_vm.isShare && _vm.poll && _vm.onlyViewMode
        ? _c(
            "div",
            {
              ref: "poll",
              class: `poll-container-v2`,
              style: { left: _vm.poll.x + "px", top: _vm.poll.y + "px" },
              attrs: { id: "poll-container" },
            },
            [
              _vm.poll.question.length > 0
                ? _c("div", { staticClass: "poll-question" }, [
                    _c("p", {}, [
                      _vm._v(_vm._s(_vm.poll.question || "Question ?")),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "poll-choices" }, [
                _c("span", { staticClass: "choice-container" }, [
                  _c(
                    "span",
                    {
                      staticClass: "text-choice",
                      attrs: { id: "poll-option-1" },
                    },
                    [_vm._v(_vm._s(_vm.poll.options[0] || "Oui"))]
                  ),
                ]),
                _c("span", { staticClass: "choice-container" }, [
                  _c(
                    "span",
                    {
                      staticClass: "text-choice",
                      attrs: { id: "poll-option-2" },
                    },
                    [_vm._v(_vm._s(_vm.poll.options[1] || "Non"))]
                  ),
                ]),
                _vm.poll.options[2]
                  ? _c("span", { staticClass: "choice-container" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text-choice",
                          attrs: { id: "poll-option-2" },
                        },
                        [_vm._v(_vm._s(_vm.poll.options[2]))]
                      ),
                    ])
                  : _vm._e(),
                _vm.poll.options[3]
                  ? _c("span", { staticClass: "choice-container" }, [
                      _c(
                        "span",
                        {
                          staticClass: "text-choice",
                          attrs: { id: "poll-option-2" },
                        },
                        [_vm._v(_vm._s(_vm.poll.options[3]))]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.isShare && _vm.slider && !_vm.onlyViewMode
        ? _c(
            "div",
            {
              ref: "slider",
              class: `slider-container ${
                !_vm.onlyViewMode && "draggable-slider"
              }`,
              style: {
                backgroundColor: _vm.sliderColorPossibles[_vm.sliderColor],
              },
              attrs: { id: "slider-container" },
              on: { click: _vm.changeSliderColor },
            },
            [
              _vm.slider.question
                ? _c(
                    "p",
                    {
                      staticClass: "slider-question",
                      style: {
                        color: _vm.sliderColor === 0 ? "#000000" : "#ffffff",
                      },
                    },
                    [_vm._v(_vm._s(_vm.slider.question || "Question ?"))]
                  )
                : _vm._e(),
              _c("div", { staticClass: "slider-slide" }, [
                _c("span", { staticClass: "emoji" }, [
                  _vm._v(_vm._s(_vm.slider.emoji)),
                ]),
                _c("div", { staticClass: "bar" }),
              ]),
            ]
          )
        : _vm._e(),
      !_vm.isShare && _vm.slider && _vm.onlyViewMode
        ? _c(
            "div",
            {
              ref: "slider",
              class: `slider-container`,
              style: {
                backgroundColor: _vm.sliderColorPossibles[_vm.sliderColor],
                left: _vm.slider.x + "px",
                top: _vm.slider.y + "px",
              },
              attrs: { id: "slider-container" },
            },
            [
              _vm.slider.question
                ? _c(
                    "p",
                    {
                      staticClass: "slider-question",
                      style: {
                        color: _vm.sliderColor === 0 ? "#000000" : "#ffffff",
                      },
                    },
                    [_vm._v(_vm._s(_vm.slider.question || "Question ?"))]
                  )
                : _vm._e(),
              _c("div", { staticClass: "slider-slide" }, [
                _c("span", { staticClass: "emoji" }, [
                  _vm._v(_vm._s(_vm.slider.emoji)),
                ]),
                _c("div", { staticClass: "bar" }),
              ]),
            ]
          )
        : _vm._e(),
      _vm.isReel && !(_vm.music && _vm.music.config)
        ? _c("div", { staticClass: "reel-modifier" }, [
            _c("div", { staticClass: "reel-background" }),
            _c(
              "a",
              {
                staticClass: "reel-avatar",
                attrs: {
                  href: `https://www.instagram.com/${_vm.pageInfo.name}`,
                  target: "blank",
                },
              },
              [
                _c("page-image-avatar", { attrs: { page: _vm.pageInfo } }),
                _c("p", { staticClass: "page-name" }, [
                  _vm._v(_vm._s(`${_vm.pageInfo.name}`)),
                ]),
                _c("p", { staticClass: "reel-follow" }, [_vm._v("Suivre")]),
              ],
              1
            ),
            _vm.reelText
              ? _c(
                  "div",
                  {
                    staticClass: "title reel-title",
                    class: [{ lorem: _vm.reelText == "", live: true }],
                  },
                  [
                    !_vm.activeEdit.title
                      ? _c(
                          "div",
                          {
                            staticClass: "title-cont",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                !_vm.activeEdit.title
                                  ? _vm.showEditPost("title")
                                  : null
                              },
                            },
                          },
                          [
                            _vm.activePrefixSuffix &&
                            _vm.bot &&
                            _vm.bot.hashtagPrefix &&
                            _vm.reelText != ""
                              ? _c("span", {
                                  staticClass: "hashtag-prefix",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      `${_vm.addHashtagsLinks(
                                        _vm.bot.hashtagPrefix
                                      )} `
                                    ),
                                  },
                                })
                              : _vm._e(),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.getMessageToPost(_vm.post).slice(0, 80)
                                ),
                              },
                            }),
                            _vm._v(
                              _vm._s(
                                _vm.getMessageToPost(_vm.post).length > 80
                                  ? "..."
                                  : ""
                              ) + "\n          "
                            ),
                            _vm.activePrefixSuffix &&
                            _vm.bot &&
                            _vm.bot.hashtag &&
                            _vm.reelText != ""
                              ? _c("span", {
                                  staticClass: "hashtag-suffix",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      ` ${_vm.addHashtagsLinks(
                                        _vm.bot.hashtag
                                      )}`
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                    _vm.reelText != ""
                      ? _c("div", { staticClass: "live-title" }, [
                          _c(
                            "span",
                            { staticClass: "btn-edit" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t(
                                      "dash.post.overlay.edit.message"
                                    ),
                                    position: "top",
                                  },
                                },
                                [
                                  _c("vs-button", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !_vm.activeEdit.title,
                                        expression: "!activeEdit.title",
                                      },
                                    ],
                                    staticClass: "button-reel",
                                    staticStyle: {
                                      background: "none !important",
                                    },
                                    attrs: {
                                      "vs-type": "filled",
                                      icon: "edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.showEditPost("title")
                                      },
                                    },
                                  }),
                                  _vm._v("\n                \n            "),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm.activeEdit.title
                            ? _c(
                                "div",
                                { staticClass: "edit-title" },
                                [
                                  _c("vs-button", {
                                    staticClass: "close button-reel",
                                    staticStyle: {
                                      background: "none !important",
                                    },
                                    attrs: {
                                      "vs-type": "filled",
                                      icon: "close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.activeEdit.title = false
                                      },
                                    },
                                  }),
                                  _c("vs-button", {
                                    staticClass: "save button-reel",
                                    staticStyle: {
                                      background: "none !important",
                                    },
                                    attrs: {
                                      "vs-type": "filled",
                                      icon: "check",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.editPost("title")
                                      },
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "textarea-emoji-picker" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "styles-text-buttons" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "emoji-trigger",
                                              class: {
                                                triggered: _vm
                                                  .styledText()
                                                  .includes("bold"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.styleSelection(
                                                    "bold"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    viewBox: "0 0 20 20",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "#888888",
                                                      d: "M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "emoji-trigger",
                                              class: {
                                                triggered: _vm
                                                  .styledText()
                                                  .includes("italic"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.styleSelection(
                                                    "italic"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    viewBox: "0 0 20 20",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "#888888",
                                                      d: "M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z ",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "emoji-trigger",
                                              class: {
                                                triggered: _vm
                                                  .styledText()
                                                  .includes("underline"),
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.styleSelection(
                                                    "underline"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    viewBox: "0 0 20 20",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "#888888",
                                                      d: "M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z",
                                                    },
                                                  }),
                                                  _c("path", {
                                                    attrs: {
                                                      fill: "#888888",
                                                      d: "M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("picker", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.showEmojiPicker,
                                            expression: "showEmojiPicker",
                                          },
                                        ],
                                        attrs: {
                                          data: _vm.emojiIndex,
                                          title: "Pick your emoji...",
                                          emoji: "point_up",
                                        },
                                        on: { select: _vm.addEmoji },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "emoji-trigger",
                                          class: {
                                            triggered: _vm.showEmojiPicker,
                                          },
                                          on: { click: _vm.toggleEmojiPicker },
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticStyle: {
                                                width: "20px",
                                                height: "20px",
                                              },
                                              attrs: { viewBox: "0 0 24 24" },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  fill: "#888888",
                                                  d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "add-mention",
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleShowMentions(
                                                "Mention"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("@")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "add-mention add-hashtag",
                                          on: {
                                            click: function ($event) {
                                              return _vm.toggleShowMentions(
                                                "Hashtag"
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v("#")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "add-mention ai-generate",
                                          on: {
                                            click: function ($event) {
                                              return _vm.getAccrochesByAI()
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("lightbulb_outline")]
                                          ),
                                        ]
                                      ),
                                      _c("vs-textarea", {
                                        ref: `inputTitle-${_vm.pageInfo.network_id}`,
                                        class: { input: true },
                                        attrs: {
                                          "vs-size": "large",
                                          color: "#B20564",
                                          name: "title",
                                          placeholder: _vm.$t(
                                            "dash.posts.overlay.description_placeholder"
                                          ),
                                          id: `inputTitle-${_vm.pageInfo.network_id}`,
                                        },
                                        model: {
                                          value: _vm.editValue.title,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.editValue,
                                              "title",
                                              $$v
                                            )
                                          },
                                          expression: "editValue.title",
                                        },
                                      }),
                                      _vm.limitText()
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "vs-textarea--count",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm.sizeCurrentMessage()
                                                  ) +
                                                  " / " +
                                                  _vm._s(_vm.limitText()) +
                                                  "\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _c("input", {
        attrs: { type: "file", id: "input-image", hidden: "" },
        on: { change: _vm.chooseImage },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "txt-container-remove-img" }, [
      _c("h3", { staticClass: "title-remove-img" }, [
        _vm._v("Abandonner la photo ?"),
      ]),
      _c("div", { staticClass: "txt-remove-img" }, [
        _vm._v(
          "\n        Si vous revenez en arrière maintenant, vous perdrez votre template\n      "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }